import React from "react";
import { Box, TextField, Typography } from "@mui/material";

const BasicInfoStep = ({ formData, onInputChange }) => {
  return (
    <Box sx={{ pt: 2 }}>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          fontSize: "0.82rem",
          color: "text.secondary",
          mb: 2.5,
        }}
      >
        Provide basic details for your automation rule
      </Typography>

      <Box display="flex" gap={2}>
        <TextField
          fullWidth
          label="Rule Name"
          value={formData.name}
          onChange={(e) => onInputChange("name", e.target.value)}
          placeholder="Enter rule name"
          required
          autoFocus
          sx={{
            flex: 1,
            "& .MuiInputLabel-root": { fontSize: "0.85rem" },
            "& .MuiOutlinedInput-root": {
              borderRadius: 1.5,
              fontSize: "0.9rem",
            },
            "& .MuiInputBase-input::placeholder": { fontSize: "0.85rem" },
          }}
        />
        <TextField
          fullWidth
          label="Description"
          value={formData.description}
          onChange={(e) => onInputChange("description", e.target.value)}
          placeholder="Description"
          multiline
          minRows={1}
          maxRows={3}
          sx={{
            flex: 1,
            "& .MuiInputLabel-root": { fontSize: "0.85rem" },
            "& .MuiOutlinedInput-root": {
              borderRadius: 1.5,
              fontSize: "0.9rem",
            },
            "& .MuiInputBase-input::placeholder": { fontSize: "0.85rem" },
          }}
        />
      </Box>
    </Box>
  );
};

export default BasicInfoStep;
